import { makeActionCreator } from '../../config/store/utils'
import { searchProvider } from '../../services/search'

export const GET_COMPARED_BUYERS = 'GET_COMPARED_BUYERS'
export const GET_COMPARED_BUYERS_ERROR = 'GET_COMPARED_BUYERS_ERROR'
export const GET_COMPARED_BUYERS_SUCCESS = 'GET_COMPARED_BUYERS_SUCCESS'
export const onGetComparedBuyers = makeActionCreator(GET_COMPARED_BUYERS)
export const onGetComparedBuyersError = makeActionCreator(GET_COMPARED_BUYERS_ERROR, 'payload')
export const onGetComparedBuyersSuccess = makeActionCreator(GET_COMPARED_BUYERS_SUCCESS, 'payload')
export const onGetComparedBuyersThunk = (term, index) => async dispatch => {
  dispatch(onGetComparedBuyers())

  try {
    const response = await searchProvider({ term, actionType: GET_COMPARED_BUYERS })

    if (response.data.success !== 200) {
      return dispatch(onGetComparedBuyersError(response.data.errores))
    }

    const result = response.data.map(result => ({
      name: result.nombreInstitucion,
      value: result.entCode
    }))

    return dispatch(
      onGetComparedBuyersSuccess({
        [index === 1 ? 'firstBuyers' : 'secondBuyers']: result
      })
    )
  } catch (error) {
    return dispatch(onGetComparedBuyersError({ error }))
  }
}
